module.exports = __webpack_public_path__ + "cf221c0763dd56dd971f027eb57faf4a.pdf";